var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextStepIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 0.83316H4.33333C2.21624 0.83316 0.5 2.5494 0.5 4.66649V35.3332C0.5 37.4503 2.21624 39.1665 4.33333 39.1665H19.6667C21.7838 39.1665 23.5 37.4503 23.5 35.3332V4.66649C23.5 2.5494 21.7838 0.83316 19.6667 0.83316Z",
    stroke: "#4540DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9044 31.5H12.0961",
    stroke: "#4540DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.625C14.4792 4.625 11.625 7.47918 11.625 11C11.625 14.5208 14.4792 17.375 18 17.375C21.5208 17.375 24.375 14.5208 24.375 11C24.375 10.5829 24.3351 10.1765 24.2595 9.78404L24.1508 9.22046L19.0604 14.3108L17.9997 15.3715L16.9391 14.3108L13.5641 10.9358L12.5034 9.87518L14.6247 7.75386L15.6854 8.81452L17.9997 11.1289L22.6551 6.47353L21.6419 5.7668C20.6099 5.04696 19.3565 4.625 18 4.625ZM23.7219 5.4067L24.5884 4.16439L23.3581 3.30625C21.839 2.24662 19.9899 1.625 18 1.625C12.8223 1.625 8.625 5.82233 8.625 11C8.625 16.1777 12.8223 20.375 18 20.375C23.1777 20.375 27.375 16.1777 27.375 11C27.375 10.3912 27.3168 9.79467 27.2052 9.21596L26.9211 7.7431L25.3192 8.05203L26.9354 6.43584L27.996 5.37518L25.8747 3.25386L24.8141 4.31452L23.7219 5.4067Z",
    fill: "#4540DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStepIcon1);
export default __webpack_public_path__ + "static/media/next-step-icon-1.15a84df7d603b465c7c2758ab018eec4.svg";
export { ForwardRef as ReactComponent };